import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '@app/shared/angular.material.module';
import { SharedComponentsModule } from '@app/shared/components/shared.module';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
// QuicklinkModule import removed
// @ts-ignore
import { UserPassportInformationComponent } from '@modules/user/components/user-passport-information/user-passport-information.component';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [],
    imports: [IonicModule, CommonModule, FontAwesomeModule, FormsModule, ReactiveFormsModule, AngularMaterialModule,
UserPassportInformationComponent],
    exports: [UserPassportInformationComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserPassportModule {}
